import { Flex, VStack, useToast } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { getUserInfo } from '../../classes/User'
import { useUserContext } from '../../context/userContext'
import ProfileDetail from '../profile/ProfileDetail'
import { AlertError } from '../shared'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const UserInfoPreview = ({ uid, short = false }) => {
    const [loadDataError, setLoadDataError] = useState(null)
    const [uData, setUData] = useState(null)
    const { userData } = useUserContext()
    const toast = useToast()

    const loadData = useRef()
    loadData.current = async () => {
        await getUserInfo(uid, userData.token)
            .then(res => {
                // console.log(res)
                setUData(res)
            })
            .catch(error => {
                // console.log(error)
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
                setLoadDataError(error)
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <Flex w="full">
            {loadDataError && <AlertError error={loadDataError} />}
            {
                uData &&
                <VStack w="full">
                    <ProfileDetail data={uData} short={short} />
                </VStack>
            }
        </Flex>
    )
}

export default UserInfoPreview
